import { ElementType } from "../IProcessData";
import { IScheduleParameters, Triggers } from "../ITriggerData";
import { IMigrationParameters } from "./index";

export function migrate(migrateParameters: IMigrationParameters) {
    const element = migrateParameters.element;
    if (element &&
        element.type === ElementType.Start &&
        element.selectedTypeId === Triggers.ScheduleTrigger.triggerType) {

        const existingParams: IScheduleParameters = element.parameters as any;
        if (existingParams.repeatDelay === undefined && existingParams.repeatDelaySeconds !== undefined) {
            const migratedParameters = Object.assign({}, existingParams, {
                startTime: existingParams.startTimeHour + ":" + existingParams.startTimeMinute,
                endTime: existingParams.endTimeHour + ":" + existingParams.endTimeMinute,
                repeatDelay: existingParams.repeatDelaySeconds,
                repeatDelaySeconds: existingParams.repeatDelaySeconds * existingParams.repeatDelayType
            });
            const migratedElement = Object.assign({}, element, { parameters: migratedParameters });
            return migratedElement;
        }
    }
    return element;
}
